import loadConfig from '../loadConfig';
import { InteractiveView } from './InteractiveView';
import { InteractiveBridge } from './InteractiveBridge';
import { applyCustomBuild } from '../apply-custom-build';
import { handleExtensionsList } from './handle-extensions-list.js';

export default Interactive;

Interactive.View = InteractiveView;
Interactive.Bridge = InteractiveBridge;

/**
 *
 * @param initialConfig
 * @param pPlayer
 * @return {Promise<InteractiveBridge>}
 * @constructor
 */
function Interactive (initialConfig, pPlayer) {
  const bridge = new Interactive.Bridge();
  const {
    configUrl,
    token,
    preferences,
    isDeviceMatch,
  } = initialConfig;

  return loadConfig(configUrl, token)
    .then(fallbackPatch(pPlayer))
    .then(applyCustomBuild(self.location))
    .then(handleExtensionsList(isDeviceMatch, preferences))
    .then(({ config, interactive_url }) => {
      const view = new Interactive.View({
        src: interactive_url,
        container: initialConfig.container,
      });
      bridge.view = view;
      bridge.setWindow(view.window);

      const create = bridge.create;
      bridge.create = () => {
        create({
          mns_config: config,
          override: initialConfig.override || [],
          key_codes: initialConfig.keyCodes || {},
        });
      };

      return bridge;
    });
}

/**
 * @todo: Есть сомнения в необходимости этого заполнения, проверить насколько это необходимо и если нет, то удалить
 * @param pPlayer
 * @return {function(*): {platform}|*}
 */
function fallbackPatch (pPlayer) {
  /**
   * @param {Config} config
   * @todo Fix eslint issue
   * @return {Config}
   */
  // eslint-disable-next-line complexity
  return (config) => {
    if (void 0 === config.config.user_info.platform) {
      config.config.user_info.platform = config.platform || pPlayer.deviceOS;
    }
    if (void 0 === config.config.user_info.model) {
      config.config.user_info.model = pPlayer.deviceModel;
    }
    if (void 0 === config.config.user_info.lang) {
      config.config.user_info.lang = pPlayer.lang;
    }
    if (void 0 === config.config.user_info.user_id) {
      config.config.user_info.user_id = pPlayer.userID;
    }
    return config;
  };
}
